import { OfferingType, OrderType } from 'stores/networkInterfaces';
import { isBuyEnabled, isSellEnabled } from 'stores/offeringUtils';
import { useStore } from 'stores/store';
import { IOfferingInfo } from 'utils/globalTypes';
import { useUserAuth } from 'utils/hooks/useUserAuth';
import { navigateToOffering, navigateToOrder } from 'utils/navigateUtils';

export const useOrderActions = (offering?: IOfferingInfo) => {
  const { ContentClientStore } = useStore();
  const authDetails = useUserAuth();
  const offeringInfo = offering ? offering : ContentClientStore.getOfferingInfo;

  const { offering_id: offeringId, offering_type: offeringType } = offeringInfo;

  const buyEnabled = isBuyEnabled(offeringInfo, authDetails);
  const sellEnabled = isSellEnabled(offeringInfo, authDetails);

  const sellPending = !!offeringInfo?.volume_pending_bid_sell_investor;
  const buyPending =
    !!offeringInfo?.volume_pending_bid_buy_investor ||
    !!offeringInfo?.volume_pending_int_buy_investor;

  const buyAction = () => {
    if (!offeringInfo?.name && !offeringInfo?.offering_name) {
      return navigateToOffering(offeringInfo?.offering_id);
    }

    return navigateToOrder(
      offeringId,
      undefined,
      offeringInfo?.offering_type == OfferingType.secondary ? OrderType.bid_buy : OrderType.int_buy
    );
  };

  const sellAction = () => {
    if (!offeringInfo?.name && !offeringInfo?.offering_name) {
      return navigateToOffering(offeringInfo?.offering_id);
    }

    navigateToOrder(offeringId, undefined, OrderType.bid_sell);
  };

  const sellActionLabel = offeringInfo?.volume_pending_bid_sell_investor ? 'My Sell Order' : 'Sell';
  const buyActionLabel =
    !offeringInfo?.name && !offeringInfo?.offering_name
      ? 'Request access'
      : offeringInfo?.volume_pending_bid_buy_investor
      ? 'My Buy Order'
      : offeringInfo?.volume_pending_int_buy_investor
      ? 'My Investment'
      : offeringInfo?.offering_type == OfferingType.secondary
      ? 'Buy'
      : 'Invest now';

  return {
    buyActionLabel,
    sellActionLabel,
    buyAction,
    sellAction,
    buyEnabled,
    sellEnabled,
    buyPending,
    sellPending,
    offeringId,
    offeringType
  };
};
